import React from "react";

export default function TemplateInventoryView({ 
  loading, results, selectedFile, searchQuery, currentPage, 
  onSearch, onPageChange, onSelect, onConfirm 
}) {
  return (
    <div className="card shadow-sm border-0 bg-white animate__animated animate__fadeIn">
      <div className="card-body p-4">
        
        {/* 🔍 1. FILTER (Search above the list) */}
        <div className="mb-4">
          <label className="extra-small fw-bold text-muted text-uppercase mb-2">Search Clean Room</label>
          <input 
            type="text" 
            className="form-control shadow-none" 
            placeholder="Filter by filename..."
            value={searchQuery} 
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>

        {/* 📋 2. THE LIST (Checkbox on the Left Hand Side) */}
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary spinner-border-sm me-2"></div>
            <span className="small fw-bold text-muted">REFRESHING INDEX...</span>
          </div>
        ) : (
          <>
            <div className="list-group list-group-flush border rounded overflow-hidden mb-4">
              {results.paginatedRows.length > 0 ? results.paginatedRows.map((file, i) => (
                <div 
                  key={i} 
                  className={`list-group-item d-flex align-items-center py-3 cursor-pointer ${selectedFile?.filename === file.filename ? 'bg-primary bg-opacity-10' : ''}`}
                  onClick={() => onSelect(file)}
                >
                  {/* 🎯 THE CHECKBOX: Anchored to the far left */}
                  <div className="pe-3 ps-2 border-end me-3">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      style={{ 
                        transform: "scale(1.3)", 
                        cursor: "pointer",
                        marginTop: "0" 
                      }}
                      checked={selectedFile?.filename === file.filename}
                      onChange={() => onSelect(file)} 
                    />
                  </div>
                  
                  {/* 🎯 THE LABEL: 14px Font Standard */}
                  <span className="fw-bold text-dark" style={{ fontSize: "14px" }}>
                    {file.filename}
                  </span>
                </div>
              )) : (
                <div className="p-5 text-center text-muted small italic">
                  No validated taxonomies found for this version.
                </div>
              )}
            </div>

            {/* 🔢 3. STANDARD PAGINATION (Start, Prev, Next, Finish) */}
            {results.totalPages > 1 && (
              <div className="d-flex justify-content-between align-items-center mb-4 bg-light p-2 rounded border shadow-sm">
                <span className="small text-muted fw-bold ps-2">
                  Page {currentPage} of {results.totalPages} 
                  <span className="mx-2">|</span> 
                  Total: {results.totalRows}
                </span>
                <div className="btn-group">
                  <button className="btn btn-sm btn-outline-dark px-3 fw-bold" onClick={() => onPageChange(1)} disabled={currentPage === 1}>START</button>
                  <button className="btn btn-sm btn-outline-dark px-3 fw-bold" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>PREV</button>
                  <button className="btn btn-sm btn-primary px-3 disabled fw-bold text-white">{currentPage}</button>
                  <button className="btn btn-sm btn-outline-dark px-3 fw-bold" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === results.totalPages}>NEXT</button>
                  <button className="btn btn-sm btn-outline-dark px-3 fw-bold" onClick={() => onPageChange(results.totalPages)} disabled={currentPage === results.totalPages}>FINISH</button>
                </div>
              </div>
            )}

            {/* 🎯 4. ACTION BUTTON (Appears only on selection) */}
            <div className="animate__animated animate__fadeInUp">
                {selectedFile && (
                    <button 
                        className="btn btn-primary w-100 fw-bold py-2 shadow-sm" 
                        onClick={onConfirm}
                    >
                        CREATE TEMPLATE
                    </button>
                )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}